import useSWR from 'swr';
import axiosInstance from 'apis/axiosInstance';
import { loadSelectedClinicId } from 'utils/storage';
import { OnlineSchedulingParams } from 'interfaces/onlineSchedulingParams';

export interface PractitionerPerformanceDetail {
  period: {
    startDate: string;
    endDate: string;
  }[];
  practitionerPerformance: {
    name: string;
    specialties: string[];
    totalAppointments: number;
    totalExistingPatients: number;
    totalNewPatients: number;
    totalProduction: number;
  }[];
}

export interface RoiPractitionerPerformanceData {
  periodData: PractitionerPerformanceDetail;
}

const useRoiPractitionerPerformance = (params: OnlineSchedulingParams) => {
  const storedId = loadSelectedClinicId();
  const clinicIds = params.clinicIds ?? [storedId];
  const query =
    params.startDate && params.endDate
      ? new URLSearchParams({
          startDate: params.startDate,
          endDate: params.endDate,
          hourType: params.hourType,
        }).toString()
      : '';

  const url =
    params.startDate && params.endDate
      ? `/rois/practitioner-performance?${query}`
      : null;

  const { data, error, isValidating, mutate } = useSWR(
    url ? [url, clinicIds] : null,
    async (...resource) => {
      const [url] = resource;
      const response = await axiosInstance.get<RoiPractitionerPerformanceData>(
        url,
        {
          params: { clinicIds },
        }
      );
      return response.data;
    }
  );

  if (!params.startDate || !params.endDate) {
    return {
      data: null,
      error: undefined,
      isLoading: false,
      isValidating: false,
      mutate: async () => {},
    };
  }

  return {
    data,
    error,
    isLoading: !data && !error,
    isValidating,
    mutate,
  };
};

export default useRoiPractitionerPerformance;
